export default __webpack_public_path__ + "static/media/finishedIsland.5c33d745.jpeg";